//import { css } from "@emotion/react"
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";

//------------------------------------------------------------------------------------
/* ManufacturerPartNumber */
export const ManufacturerPartNumberField = () => {
	const productDetailsState = useProductDetailsState();
	const translate = useTranslate();
	return (
		<div className="field">
			<div className="caption">{translate("Manufacturer Part Number")}:</div>
			<div className="value">
				{productDetailsState.get().product?.ManufacturerPartNumber}
			</div>
		</div>
	);
};
